import { HttpError } from '../error';
import buildRequest from './buildRequest';

const REQUEST_TIMES = 5; // 请求错误时重复请求次数
const ERROR_CODE = -9999; // try catch捕获异常码
class HttpClassBaseClass {
  commonHttpCall({ fullPath, data, options }) {
    let ISRETRY = false;
    let TIMES = REQUEST_TIMES;
    if (data) {
      const { isRetry = false, times = REQUEST_TIMES } = data;
      ISRETRY = isRetry;
      TIMES = times;
    }
    const call = async () => {
      try {
        return buildRequest({ fullPath, data, options })
          .then(async (res) => {
            return res;
          })
          .catch((err) => {
            throw err;
          });
      } catch (err) {
        // 此处进行错误处理
        throw err;
      }
    };
    ISRETRY && this.retry(call, TIMES, (err) => err.code === ERROR_CODE)();
    return call();
  }

  // TODO
  uploadFile() {
    /**
     * 1. 支持文件大小判断（可外部传入限制的大小）
     * 2. 判断上传文件类型枚举（binary，formData，arrayBuffer）
     * 3. 文件格式PDF，图片，Excel，world
     */
  }
  // TODO 缓存相关：https://juejin.cn/post/6844903843092758541
  /**
   *Promise缓存：我们想在各个复杂组件分别调用api，而不想对组件进行组件通信数据时候，便会遇到此场景。
   const promiseCache = new Map()
    getWares() {
        const key = 'wares'
        let promise = promiseCache.get(key);
        // 当前promise缓存中没有 该promise
        if (!promise) {
            promise = request.get('/getWares').then(res => {
                // 对res 进行操作
                ...
            }).catch(error => {
                // 在请求回来后，如果出现问题，把promise从cache中删除 以避免第二次请求继续出错S
                promiseCache.delete(key)
                return Promise.reject(error)
            })
            promiseCache.set(key, promise)
        }
        // 返回promise
        return promise
    }
   */
  retry(fetch, times, should) {
    let timesSave = times;
    const execute = async (...args) => {
      try {
        timesSave -= 1;
        return await fetch(...args);
      } catch (err) {
        if (should(err) && timesSave === 0) {
          return execute(...args);
        }
        throw err;
      }
    };
    return execute;
  }

  handleError(code, message) {
    return new HttpError(code, message);
  }
}

export const api = new HttpClassBaseClass();

export default HttpClassBaseClass;
